import { createSlice } from "@reduxjs/toolkit";

interface UnsignedFilesState {
  /** Bumped when the list of documents waiting for others should be loaded again. */
  refreshNonce: number;
}

const initialState: UnsignedFilesState = {
  refreshNonce: 0,
};

const unsignedFilesSlice = createSlice({
  name: "unsigned-files",
  initialState,
  reducers: {
    refreshRequested(state: UnsignedFilesState) {
      state.refreshNonce += 1;
    },
  },
});

const { actions, reducer } = unsignedFilesSlice;

export const { refreshRequested } = actions;
export default reducer;
